var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.direction, _vm.color],attrs:{"id":"triangle","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M50 0 L0 100 L100 100 Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }